export default __webpack_public_path__ + "static/media/buyers.ab956e98.svg";